export default __webpack_public_path__ + "static/media/main-banner-1.e335f3bc.jpg";